import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import { authorize } from "../../services/authService";
import { useNavigate } from 'react-router-dom';
import { getFileSign } from '../../utils/indexedDB';

export const ComponentAsideShare = ({ fileName }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [fName, setFName] = useState(fileName || localStorage.getItem('fileName'));
    sessionStorage.setItem('sentToSign', 'false');
    const handleDownload = async () => {
        try {
            const fileBlob = await getFileSign(fName);
            const url = window.URL.createObjectURL(fileBlob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${fName}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Failed to download the file:', error);
        }
    };

    const handleClose = () => {
        navigate('/');
    };

    return (
        <div className="component-aside-default">
            <div className="component-actions">
                <button
                    style={{ marginTop: '10px' }}
                    type="button"
                    className="btn-medium btn-primary modal-trigger"
                    onClick={handleDownload}
                >
                    {t('componentAsideShare.download')}
                </button>
                <button
                    style={{ marginTop: '10px' }}
                    type="button"
                    className="btn-medium btn-secondary"
                    onClick={handleClose}
                >
                    {t('componentAsideShare.close')}
                </button>
            </div>
        </div>
    );
};
